/**
 * function that rounds a floating-point number to a specified step, but if the number is an integer
 * it should return the original integer.
 *
 * @function
 * @param {number} number - Number to be rounded
 * @param {number} step - The round step to round the number
 * @returns {number} The rounded number
 */
export const roundToStep = (number: number, step: number) => {
  if (Number.isInteger(number)) {
    return number;
  }

  const roundedNumber: number = Math.round(number / step) * step;
  return roundedNumber;
};
